import { apiSlice } from '../../api/apiSlice';
import { store } from '../../store/store';

export function recalculateAssociate(employeeNumber:string,scorecardVersionId?:number,year?:number,month?:number,requestBy?:string): void {
   store.dispatch(apiSlice.endpoints.recalculateAssociate.initiate({
    employeeNumber,
    scorecardVersionId,
    year,
    month,
    requestBy
}));

}
